import React from 'react';

export const PaymentSdkContext = React.createContext(null);
PaymentSdkContext.displayName = 'PaymentSdkContext';

export const PaymentSdkContextProvider = PaymentSdkContext.Provider;
